<template>
  <v-container fluid>
    <v-card class="sv-card pa-4">
      <v-row no-gutters>
        <v-col cols="12">
          <v-row no-gutters>
            <v-col cols="12" class="pb-2">
              <filter-dialog
                v-model="filterDialog"
                :filters.sync="filters"
                :schema="filterSchema"
                @refresh="loadHistory"
                @apply="onFilterChange"
                @reset="onFilterChange"
                @remove="onFilterChange"
              />
            </v-col>
            <v-col cols="12" class="sv-datatable">
              <v-card flat>
                <v-data-table
                  v-resize="onResize"
                  fixed-header
                  class="v-datatable-stripped"
                  calculate-widths
                  :options.sync="options"
                  :headers="headers"
                  :items="history"
                  :server-items-length="count"
                  :loading="loading"
                  :height="height(252)"
                  :footer-props="{ itemsPerPageOptions: [20, 50, 100] }"
                >
                  <!-- eslint-disable-next-line vue/valid-v-slot -->
                  <template #item.object_ident="{ item }">
                    <v-tooltip v-if="item.object_ident" bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          text
                          color="primary"
                          :disabled="!item.action_page"
                          v-on="on"
                          @click="
                            openHistoryDialog(
                              item.object_ident,
                              item.action_page
                            )
                          "
                        >
                          {{ item.object_ident }}
                        </v-btn>
                      </template>
                      <span>История объекта</span>
                    </v-tooltip>
                  </template>
                  <!-- eslint-disable-next-line vue/valid-v-slot -->
                  <template #item.action_name="{ item }">
                    {{ actionNames[item.action_name] || item.action_name }}
                  </template>
                  <!-- eslint-disable-next-line vue/valid-v-slot -->
                  <template #item.action_page="{ item }">
                    {{ getPagePath(item) }}
                  </template>
                  <!-- eslint-disable-next-line vue/valid-v-slot -->
                  <template #item.actions="{ item }">
                    <action-col v-if="item.details_type > 0">
                      <action-col-btn
                        :id="`btn-view-details-${item.id}`"
                        tooltip="Детализация"
                        @click="
                          showHistoryDetails(
                            item.id,
                            item.details_type,
                            item.action_page,
                            item.action_name
                          )
                        "
                      >
                        mdi-information-variant
                      </action-col-btn>
                    </action-col>
                  </template>
                </v-data-table>

                <history-modal
                  v-model="objectHistory.dialog"
                  :item-id="objectHistory.ident || null"
                  :action-page="objectHistory.page || null"
                />

                <history-detail-modal
                  v-model="actionDetail.dialog"
                  :item-history-id="actionDetail.id"
                  :detail-type="actionDetail.type"
                  :scope-name="actionDetail.scope"
                  :action-name="actionDetail.action"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>
<script>
import NotificationMixin from "@/mixins/NotificationMixin";
import DialogMixin from "@/mixins/DialogMixin";
import CheckPermissionMixin from "@/mixins/CheckPermissionMixin";
import ResizeMixin from "@/mixins/ResizeMixin";
import QueryMixin from "@/mixins/QueryMixin";
import HistoryModal from "@/components/HistoryModal.vue";
import HistoryDetailModal from "@/components/HistoryDetailModal.vue";

import FilterDialog from "@/components/Filters/FilterDialog.vue";
import SearchFilter from "@/components/Filters/SearchFilter.vue";
import DatetimeRangeFilter from "@/components/Filters/DatetimeRangeFilter.vue";
import SelectFilter from "@/components/Filters/SelectFilter.vue";

import HistoryActionsRepository from "@/api/history.js";
import { useMenuTree } from "@/use/MenuTree.js";
import Const from "@/utils/Const.js";

export default {
  components: { HistoryModal, HistoryDetailModal, FilterDialog },
  mixins: [
    NotificationMixin,
    DialogMixin,
    CheckPermissionMixin,
    ResizeMixin,
    QueryMixin
  ],
  data: () => ({
    loading: false,
    count: 0,
    objectHistory: {
      dialog: false,
      page: null,
      ident: null
    },
    actionDetail: {
      dialog: false,
      id: null,
      type: 0,
      scope: "",
      action: ""
    },
    filterDialog: false,
    filters: {},
    options: {},
    history: []
  }),
  computed: {
    navMenu() {
      return this.$store.getters.getNavMenu;
    },
    headers() {
      return [
        { text: "ID", value: "id" },
        { text: "Дата", value: "dt" },
        { text: "Пользователь", value: "user_name" },
        { text: "Действие", value: "action_name" },
        { text: "ID объекта", value: "object_ident" },
        {
          text: "Страница",
          value: "action_page",
          sortable: false,
          class: "text-no-wrap"
        },
        { text: "IP", value: "ip" },
        {
          text: "",
          value: "actions",
          sortable: false,
          align: "center",
          width: "80px"
        }
      ];
    },
    actionNames() {
      return Const.ActionNames;
    },
    filterSchema() {
      return {
        residentData: {
          filters: {
            userName: {
              component: SearchFilter,
              title: "Пользователь",
              filterBind: { maxlength: 50 }
            },
            actionName: {
              component: SelectFilter,
              title: "Действие",
              filterBind: {
                items: Object.entries(this.actionNames).map(entry => ({
                  id: entry[0],
                  name: entry[1]
                })),
                valueItem: "id",
                textItem: "name"
              }
            },
            objectIdent: {
              component: SearchFilter,
              title: "Идентификатор объекта",
              filterBind: {
                disableLike: true,
                maxlength: 10
              }
            },
            actionPage: {
              component: SearchFilter,
              title: "Страница",
              filterBind: {
                maxlength: 100
              }
            },
            ip: {
              component: SearchFilter,
              title: "IP",
              filterBind: { maxlength: 50 }
            },
            dt: {
              component: DatetimeRangeFilter,
              title: "Дата"
            },
            details: {
              component: SearchFilter,
              title: "Детализация",
              filterBind: { maxlength: 100 }
            }
          }
        }
      };
    }
  },
  watch: {
    options: {
      handler() {
        this.loadHistory();
      },
      deep: true
    }
  },
  methods: {
    getPagePath(item) {
      if (item.action_page == "Node") {
        return item.titles;
      } else {
        const menu = this.navMenu;
        const titles = this.recursGetNavTitles(menu, item.action_page);
        return titles.map(item => item.title).join(" / ");
      }
    },
    openHistoryDialog(objectIdent, actionPage) {
      this.objectHistory.ident = objectIdent;
      this.objectHistory.page = actionPage;
      this.objectHistory.dialog = true;
    },
    showHistoryDetails(id, type, scope, action) {
      this.actionDetail.id = id;
      this.actionDetail.type = type;
      this.actionDetail.scope = scope;
      this.actionDetail.dialog = true;
      this.actionDetail.action = action;
    },
    async loadHistory() {
      try {
        this.loading = true;
        const params = this.getQueryOptions();
        const { data } = await HistoryActionsRepository.getHistory(params);
        this.history = data.history;
        this.count = data.count;
      } catch (error) {
        return true;
      } finally {
        this.loading = false;
      }
    },
    onFilterChange() {
      this.options.page = 1;
      this.loadHistory();
    },

    clear() {
      this.filters = {};
      this.loadHistory();
    }
  },
  setup() {
    // методы получения словаря и отдельной словарной статьи
    const { recursGetNavTitles } = useMenuTree();

    return {
      recursGetNavTitles
    };
  }
};
</script>
